import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import { useSamplesLaboratoryListQuery } from "@/services/backend/samples/api/lab-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DeleteLabDialog } from "@/services/backend/samples/components/delete-lab-dialog";
import { Button } from "@/shared/components/ui/button";
import { Search } from "lucide-react";
import { Laboratory } from "@/services/backend/samples/types/laboratory";
import { AddressToLine } from "../../addresses/components/address-to-line";

export function LabTable({
  navigateTo,
}: {
  navigateTo?: (lab: Laboratory) => void;
}) {
  const { data, isLoading, error } = useSamplesLaboratoryListQuery({});

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("Name")}</TableHead>
          <TableHead>{t("Adresse")}</TableHead>
          <TableHead>{t("API")}</TableHead>
          <TableHead className="text-right">{t("Aktionen")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.labs.map((lab) => (
          <TableRow key={lab.id}>
            <TableCell>
              {navigateTo ? (
                <Button
                  size="sm"
                  variant="link"
                  className="text-foreground"
                  onClick={() => navigateTo(lab)}
                >
                  {lab.name}
                </Button>
              ) : (
                lab.name
              )}
            </TableCell>
            <TableCell>
              <AddressToLine address={lab.address} />
            </TableCell>
            <TableCell>{lab.api || t("Keine")}</TableCell>
            <TableCell className="space-x-2 text-right">
              {navigateTo && (
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => navigateTo(lab)}
                >
                  <Search className="size-4" />
                </Button>
              )}
              <DeleteLabDialog lab={lab} />
            </TableCell>
          </TableRow>
        ))}
        {isLoading && (
          <TableRow>
            <TableCell colSpan={4} className="animate-pulse">
              {t("Loading...")}
            </TableCell>
          </TableRow>
        )}
        {error && (
          <TableRow>
            <TableCell colSpan={4}>
              <RTKQueryErrorAlert error={error} />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
